<template>
	<div>
		<div class="mb-2">
			<h6 class="font-medium">{{ value.title }}</h6>
			<OptionValue
					v-for="value in value.booked_values"
					:key="value.id"
					:value="value"
			></OptionValue>
		</div>
	</div>
</template>

<script lang="ts" setup>
import OptionValue from "./OptionValue.vue"
import {BookedOptionInterface} from "@/js/interfaces/checkout"

defineProps<{
	value: BookedOptionInterface
}>()
</script>
